module.exports = __webpack_public_path__ + "img/yq-pic2.83b4e949.png";